module.exports = __webpack_public_path__ + "img/3-insurance-zone-home.4c534f58.jpg";